'use client';

import { c as _c } from "react/compiler-runtime";
import toast from '@shared/utils/helpers/toast';
import { useQueryClient } from '@tanstack/react-query';
import { Trash2 } from 'lucide-react';
import { useState } from 'react';
import { client } from '../../utils/trpc';
import Button from '../common/Button';
import Modal, { ModalContent, ModalFooter, ModalHeader } from '../HOC/Modal';

// Start over, as opposed to un-syncing one folder. Vault-wide, so it lives in
// the header rather than inside the Sync tab.
const ResetVaultButton = () => {
  const $ = _c(9);
  const queryClient = useQueryClient();
  const [confirming, setConfirming] = useState(false);
  const [running, setRunning] = useState(false);
  let t0;
  if ($[0] !== queryClient) {
    t0 = async () => {
      setRunning(true);
      const [err, res] = await client.onedriveEmbed.resetVault.mutate();
      setRunning(false);
      setConfirming(false);
      if (err) {
        toast(err.message || "Could not reset the vault", "", "error");
        return;
      }
      toast(`Vault reset — ${res.folders} folders and ${res.posts} documents removed`, "", "success");
      queryClient.invalidateQueries({
        queryKey: ["onedriveEmbed"]
      });
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const confirm = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Button variant="CLEAR" text="Reset vault" classNames="px-2.5 py-1 text-xs font-normal text-textSecondary" icon={<Trash2 height={13} width={13} />} onClick={() => setConfirming(true)} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== confirm || $[4] !== confirming || $[5] !== running) {
    t2 = confirming && <Modal maxWidth={460} closeHandler={() => setConfirming(false)}><ModalHeader closeHandler={() => setConfirming(false)}>Reset the vault?</ModalHeader><ModalContent><p className="text-sm text-textSecondary">Untracks every folder and{" "}<span className="text-textPrimary">deletes every synced document</span>{" "}— their posts, search chunks and the tags they added. Your OneDrive files are untouched and the connection stays, so you can sync again from scratch.</p></ModalContent><ModalFooter><Button variant="SECONDARY" text="Cancel" onClick={() => setConfirming(false)} /><Button variant="DANGER" text={running ? "Resetting\u2026" : "Reset vault"} disabled={running} onClick={() => void confirm()} /></ModalFooter></Modal>;
    $[3] = confirm;
    $[4] = confirming;
    $[5] = running;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default ResetVaultButton;